<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('ajoutEditContrat.materiel.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-6">
          <div class="columns">
            <div class="column is-narrow" v-if="isViewAjout">
              <selecteur-action
                @handleAction="handleActions"
                :options='actions'
                :placeholder='$t("general.placeHolder.groupedAction")'
                :titleButton="'general.button.apply'"
                :elementsSelectionnes="hasSomethingSelected"
              ></selecteur-action>
            </div>
            <div class="column is-4">
              <div v-if="contrat.contratsMateriels.length > 0">
                <div class="field has-addons">
                  <div class="control inputSearch has-icons-left is-clearfix">
                    <b-input :placeholder="$t('ajoutEditContrat.materiel.actions.search')"
                             v-model="search" type="search">
                    </b-input>
                    <b-icon class="icon is-left"
                            icon="magnify"></b-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-6" v-if="isViewAjout">
          <div class="columns is-justify-content-flex-end">
            <b-autocomplete class="dropdown is-bottom-left column is-5"
                            v-model="searchAutocomplete"
                            :open-on-focus="false"
                            :data="autocompleteMaterielList"
                            field="libelle"
                            :loading="isFetching"
                            @select="materiel => selectMateriel(materiel)"
                            @input="getAsyncMaterielData"
                            :placeholder="$t('ajoutEditContrat.materiel.actions.associer')">
              <template slot="empty">
                <div v-if="!isFetching">
                  {{$t('ajoutEditContrat.materiel.actions.noResult')}}
                </div>
                <div v-else>
                  {{$t('ajoutEditContrat.materiel.actions.searchEnCours')}}
                </div>
              </template>
            </b-autocomplete>
            <div class="column is-narrow">
              <div class="button is-primary"
                   @click="ajouterMateriel">
                {{ $t('ajoutEditContrat.materiel.actions.addMaterielMultiple') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="has-text-centered has-background-background pdt-20px pdb-20px"
           v-if="contrat.contratsMateriels.length === 0">
        <h1 class="title is-size-4">
          {{ $t('ajoutEditContrat.materiel.aucunMateriel')}}
        </h1>
        <p> {{ $t('ajoutEditContrat.materiel.addMateriel')}} </p>
      </div>
      <div v-else-if="filteredEmplacement.length > 0">
        <div class="mgl-10px" v-if="emplacements.length > 0 && isViewAjout">
          <header-emplacement-dispositif-materiel-face-picker :emplacements="emplacements">
          </header-emplacement-dispositif-materiel-face-picker>
        </div>
        <div class="columns is-justify-content-end" v-if="elementInactif > 0">
            <div class="column is-narrow is-align-self-center">
                <div class="lien has-text-right">
                    <span class="is-cursor-pointer" @click="displayInactif = !displayInactif">
                        {{ displayInactif
                            ? $t('ajoutEditContrat.materiel.displayActif')
                            : $t('ajoutEditContrat.materiel.displayInactif')
                        }}
                     </span>
                 </div>
             </div>
        </div>
        <ligne-emplacement
              v-for="(emplacement, index) in filteredEmplacement"
              :key="emplacement.id"
              :emplacement="emplacement" class="mgt-15px"
              :dateDebut="getDateDebut"
              :dateFin="getDateFin"
              :index="index"
              :afficherCheckbox="isViewAjout"
              :afficherCheckboxFace="false"
              :afficherCheckboxMateriel="isViewAjout"
              :displayInactif="displayInactif"
              v-show="displayInactif || emplacement.actif">
        </ligne-emplacement>
        <scrollLoader :loader-method="addEmplacementToLoad" :loader-disable="loaderStatus
      || filteredEmplacement.length < currrentPageSize"
                      :loader-distance="400" :loader-size="50">
        </scrollLoader>
      </div>
      <div class="has-text-centered has-background-background pdt-20px pdb-20px"
           v-else>
        <h1 class="title is-size-4">
          {{ $t('ajoutEditContrat.materiel.aucunResult')}}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { getAll, get } from '@/api/gabed/materiel';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { SET_CONTRAT } from '@/store/modules/baux/contrat-mutation-type';
import scrollLoader from '@/components/general/scrollLoader';
import { syncDeleteMateriel, syncAddMateriel } from '@/services/baux/contrat/syncMaterielProduitId';
import {
  createDispositif,
  createEmplacementDispositifMaterielFace,
  getEmplacementDispositifMaterielAndFaceFromListeMateriel,
}
  from '@/services/gabed/materiel/getEmplacementDispositifMaterielAndFaceFromListeMateriel';
import ligneEmplacement from '@/components/gabed/general/ligneEmplacement';
import cloneDeep from 'lodash/cloneDeep';
import selecteurAction from '@/components/general/selecteurAction';
import { ACTION_DELETE } from '@/configuration/general/actionsConf';
import headerEmplacementDispositifMaterielFacePicker
  from '@/components/gabed/general/headerEmplacementDispositifMaterielFacePicker';
import moment from 'moment';
import messageSucces from '@/services/general/messageSucces';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Contrat = createNamespacedHelpers('contrat');

export default {
  props: {
    isViewAjout: {
      type: Boolean,
      required: true,
    },
    contrat: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      searchAutocomplete: null,
      autocompleteMaterielList: [],
      selectedMateriel: null,
      isFetching: false,
      loaderStatus: false,
      currrentPageSize: 20,
      rangeToAddAfterEndOfScroll: 5,
      emplacements: [],
      displayInactif: false,
      actions: [
        { action: ACTION_DELETE, translation: 'ajoutEditContrat.actions.remove' },
      ],
    };
  },
  components: {
    ligneEmplacement,
    selecteurAction,
    scrollLoader,
    headerEmplacementDispositifMaterielFacePicker,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    getDateDebut() {
      return moment(new Date()).toDate();
    },
    getDateFin() {
      return moment(new Date()).toDate();
    },
    filteredEmplacement() {
      return this.emplacements.filter((emplacement) => {
        const dispositif = emplacement.dispositifs.filter((dispositif) => {
          const materielFind = dispositif.materiels.filter((materiel) => {
            return materiel.code
            && materiel.code.toLowerCase().includes(this.search.toLowerCase());
          });
          return materielFind.length === 0;
        });
        return dispositif.length === 0;
      }).slice(0, this.currrentPageSize);
    },
    hasSomethingSelected() {
      return this.emplacements.filter((emplacement) => {
        const dispositif = emplacement.dispositifs.filter((dispositif) => {
          const materiel = dispositif.materiels.filter((materiel) => {
            return materiel.selected;
          });
          return materiel.length > 0 || dispositif.selected;
        });
        return dispositif.length > 0 || emplacement.selected;
      }).length > 0;
    },
    elementInactif() {
      let count = 0;
      this.emplacements.forEach(emp => {
        if (!emp.actif) {
          count += 1;
        }
        emp.dispositifs.forEach(disp => {
          if (!disp.actif) {
            count += 1;
          }
          disp.materiels.forEach(mat => {
            if (!mat.actif) {
              count += 1;
            }
            mat.faces.forEach(face => {
              if (!face.actif) {
                count += 1;
              }
            });
          });
        });
      });

      return count;
    },
  },
  methods: {
    ...Contrat.mapMutations({
      setContrat: SET_CONTRAT,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    deleteSelectedMateriel() {
      this.emplacements.forEach((emplacement) => {
        emplacement.dispositifs.forEach((dispositif) => {
          dispositif.materiels = dispositif.materiels.filter((materiel) => {
            return !materiel.selected;
          });
        });
      });
      this.emplacements.forEach((emplacement) => {
        emplacement.dispositifs = emplacement.dispositifs.filter((dispositif) => {
          return !dispositif.selected;
        });
      });
      this.emplacements = this.emplacements.filter((emplacement) => {
        return !emplacement.selected;
      });
      this.saveMaterielInContrat();
    },
    saveMaterielInContrat() {
      const materiels = [];
      this.emplacements.forEach((emplacement) => {
        emplacement.dispositifs.forEach((dispositif) => {
          dispositif.materiels.forEach((materiel) => {
            materiels.push({
              materiel: materiel,
              materielId: materiel.id,
            });
          });
        });
      });
      this.contrat.contratsMateriels = this.contrat.contratsMateriels.filter(cm => {
        return materiels.map(m => m.materielId).includes(cm.materielId);
      });
      syncDeleteMateriel(this.contrat);
      materiels.filter(m => {
        return !this.contrat.contratsMateriels.map(cm => cm.materielId).includes(m.materielId);
      })
        .forEach(m => {
          this.contrat.contratsMateriels.push(m);
        });
    },
    handleActions(action) {
      switch (action) {
        case ACTION_DELETE:
          this.deleteSelectedMateriel();
          break;
        default:
          break;
      }
    },
    addEmplacementToLoad() {
      if (this.currrentPageSize >= this.emplacements.length) {
        this.loaderStatus = true;
        this.currrentPageSize = this.emplacements.length;
        return;
      }
      this.currrentPageSize += this.rangeToAddAfterEndOfScroll;
    },
    ajouterMateriel() {
      this.setContrat(this.contrat);
      this.$router.push({ name: 'l.baux.contrat-ajout-materiel' });
    },
    getAsyncMaterielData: debounce(async function materielData() {
      try {
        this.autocompleteMaterielList = [];
        if (this.searchAutocomplete.length === 0) return;
        this.isFetching = true;
        const result = {
          query: {
            auto: this.searchAutocomplete,
            societeId: this.societeActiveId,
            actif: true,
          },
        };
        const materielsFind = (await getAll(result)).data.result.items;
        const materielsList = materielsFind.filter((materiel) => {
          return !this.contrat.contratsMateriels.find((contratMateriel) => {
            return contratMateriel.materielId === materiel.id;
          });
        });
        materielsList.forEach((materiel) => {
          materiel.libelle = materiel.code;
          materiel.libelle += materiel.type && materiel.type.libelle ? ' - ' + materiel.type.libelle : '';
          materiel.libelle += materiel.format && materiel.format.libelle ? ' - ' + materiel.format.libelle : '';
          materiel.libelle += materiel.dispositif && materiel.dispositif.adresse ? ' - ' + adressFullStringGetter(materiel.dispositif.adresse) : '';
        });
        this.autocompleteMaterielList = materielsList;
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
    async selectMateriel(materielSelect) {
      if (!materielSelect) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const materiel = (await get(materielSelect.id)).data.result;
        if (!materiel) {
          loadingComponent.close();
          return;
        }
        materiel.selected = false;
        materiel.open = false;
        materiel.dispositif.selected = false;
        materiel.dispositif.open = false;
        this.contrat.contratsMateriels.push({
          materiel: materiel,
          materielId: materiel.id,
          isNew: true,
        });
        this.addMaterielInEmplacement(materiel);
        syncAddMateriel(this.contrat);
        messageSucces(this.$i18n.t('ajoutEditContrat.materiel.successAdd'));
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    addMaterielInEmplacement(materiel) {
      const emplacementExistant = this.emplacements.find((emplacement) => {
        return emplacement.id === materiel.dispositif.emplacementId;
      });
      if (!emplacementExistant) {
        createEmplacementDispositifMaterielFace(materiel, this.emplacements);
        return;
      }
      const dispositiffExistant = emplacementExistant.dispositifs.find((dispositif) => {
        return dispositif.id === materiel.dispositifId;
      });
      if (!dispositiffExistant) {
        createDispositif(materiel, emplacementExistant);
        return;
      }
      dispositiffExistant.materiels.push(materiel);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const emplacement = getEmplacementDispositifMaterielAndFaceFromListeMateriel(
        cloneDeep(
          this.contrat.contratsMateriels.map((materielInformation) => materielInformation.materiel),
        ),
        [],
      );
      this.emplacements = emplacement;
      await this.loadParametres([PARAMETRES_KEYS.materielType, PARAMETRES_KEYS.materielFormat]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
